'use es6';

import getTokenParts from './getTokenParts';
const encodeToken = (formId, portalId, version = 1) => {
  const {
    legacyPrefix,
    versionSymbol,
    encodedFormId,
    encodedPortalId
  } = getTokenParts({
    formId,
    portalId,
    version
  });
  return `${legacyPrefix}${versionSymbol}${encodedFormId}${encodedPortalId}`;
};
export default encodeToken;